import _ from "lodash";
import { useEffect, useRef } from "react";

/**
 * @description
 * Hook to save AI usage metrics ID and associated metadata.
 * Tracks the latest assistant message and updates conversation state when metrics ID changes.
 */
export const useSaveAiUsageMetricsId = props => {
  const {
    step,
    messages,
    aiConversationId,
    updateAIConversation,
    conversationMetadata,
    updateAIAssessmentTools,
  } = props;
  const isProcessedRef = useRef(false);

  // * Save metrics when ID changes
  useEffect(() => {
    if (step === 2 && !isProcessedRef.current && _.size(messages) >= step) {
      const preStepDebugInfo = _.get(_.first(messages), "node", null);
      const debugInfo = _.get(_.last(messages), "node", null);
      if (!_.get(debugInfo, "usageMetricsId", null)) return;
      isProcessedRef.current = true;

      const stepOnePayload = {
        usageMetricsId: _.get(preStepDebugInfo, "usageMetricsId", null),
        metaData: _.get(preStepDebugInfo, "metadata", null),
      };
      const stepTwoPayload = {
        usageMetricsId: _.get(debugInfo, "usageMetricsId", null),
        metaData: _.get(debugInfo, "metadata", null),
      };

      updateAIAssessmentTools({
        preStepDebugInfoMetaData: {
          [aiConversationId]: stepOnePayload,
        },
        debugInfoMetaData: {
          [aiConversationId]: stepTwoPayload,
        },
      });

      updateAIConversation({
        input: {
          id: aiConversationId,
          metadata: {
            ...conversationMetadata,
            preStepDebugInfo: stepOnePayload,
            debugInfo: stepTwoPayload,
          },
        },
      });
    }
  }, [
    step,
    messages,
    aiConversationId,
    updateAIConversation,
    conversationMetadata,
    updateAIAssessmentTools,
  ]);

  return null;
};
